import React, { Component } from 'react';
import { Table } from 'antd';

class list extends Component {
    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.props;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.props.search({ pagination, sortParams });
    }

    getColumns = () => {
        const { config: { canEdit } } = this.props;
        const columns = [];
        columns.push({
            title: '考核时间',
            dataIndex: 'inspectionTimeShow',
            key: 'inspectionTimeShow',
            fixed: 'left',
            width: 85,
        }, {
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 80,
            sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 80,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 110,
        }, {
            title: '鼓励团队成员',
            dataIndex: 'encourageTeamMembers',
            key: 'encourageTeamMembers',
            width: 90,
        }, {
            title: '承担PA或协助主管工作',
            dataIndex: 'assistPaSupervisor',
            key: 'assistPaSupervisor',
            width: 85,
        }, {
            title: '协助LM协同访视',
            dataIndex: 'assistVisit',
            key: 'assistVisit',
            width: 110,
        }, {
            title: '协助组织团队活动(城市级别及以上)',
            dataIndex: 'assistOrganizeEvent',
            key: 'assistOrganizeEvent',
            width: 115,
        }, {
            title: '合计',
            dataIndex: 'total',
            key: 'total',
        }, {
            title: '主管总结性评语',
            dataIndex: 'comments',
            key: 'comments',
            width: 160,
        }, {
            title: '评价人',
            dataIndex: 'appraiseUser',
            key: 'appraiseUser',
            render: (text, record) => {
                const { appraiseUserName, appraiseUserCode } = record;
                return  (
                    appraiseUserName ?
                        <span>
                            {appraiseUserName}
                            <br />
                            {appraiseUserCode ? `(${appraiseUserCode})` : ''}
                        </span>
                    :
                        ''
                );
            }
        }, {
            title: '评价时间',
            dataIndex: 'appraiseTime',
            key: 'appraiseTime',
            width: 85,
        });
        if (canEdit == 'true') {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                fixed: 'right',
                width: 60,
                render: (text, record) => {
                    return <a onClick={() => this.props.updateScore(record)}>加分</a>
                }
            })
        }
        return columns;
    }

    getDataSource = () => {
        const { data } = this.props;
        const dataSource = data.map((item, index) => ({
            index,
            ...item,
        }));
        return dataSource;
    }

    render() {
        const { loading, pagination } = this.props;
        return (
            <Table
                loading={loading}
                scroll={{ x: 1200 }}
                pagination={pagination}
                columns={this.getColumns()}
                dataSource={this.getDataSource()}
                rowKey={record => record.index}
                onChange={this.handleTableChange}
            />
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/user/crcTeamContributeScore/List.js